const Chip = ({ active, onClick, children, testId }) => (
  <button
    type="button"
    data-testid={testId}
    onClick={onClick}
    className={`px-4 py-2 rounded-full text-sm font-medium border transition-colors active:scale-95 ${
      active ? "bg-slate-900 border-slate-900 text-white" : "border-slate-300 text-slate-700 hover:border-slate-500"
    }`}
  >
    {children}
  </button>
);

/**
 * The blue grade box: shown after DOB in onboarding and again before generating a curriculum.
 * `grade` is the learner's current answer, `recommended` is derived from their age.
 */
export const GradeBox = ({ grade, recommended, age, onChange, note, testId = "grade-box" }) => (
  <div className="p-5 rounded-2xl bg-blue-50/70 border border-blue-200" data-testid={testId}>
    <p className="text-sm text-slate-700">
      {recommended ? (
        <>
          Learners {age ? `your age (${age})` : "your age"} are usually in{" "}
          <span className="font-semibold">grade {recommended}</span>. Is that about right? Change it if not — your answer
          is the one we use.
        </>
      ) : (
        <>Which grade should we aim at? Pick the level that feels right — your answer is the one we use.</>
      )}
    </p>
    <div className="mt-3 flex flex-wrap gap-2">
      {[...Array(12)].map((_, i) => {
        const g = String(i + 1);
        return (
          <Chip key={g} testId={`grade-box-${g}`} active={grade === g} onClick={() => onChange(g)}>
            {g}
          </Chip>
        );
      })}
      <Chip testId="grade-box-unknown" active={grade === ""} onClick={() => onChange("")}>
        I don't know
      </Chip>
    </div>
    {grade === "" && (
      <p className="mt-3 text-xs text-slate-500">Then we'll start from foundations and move up as fast as you do.</p>
    )}
    {note && <p className="mt-3 text-xs text-slate-500">{note}</p>}
  </div>
);
